module.exports = __webpack_public_path__ + "img/retro-soul.434d5697.png";